<div>
  <mat-form-field style="width: 100%;">
    <mat-label>{{placeholder()}}</mat-label>
    <mat-select [formControl]="elementCtrl" #singleSelect [disableOptionCentering]="true">
      <mat-option>
        <ngx-mat-select-search [formControl]="elementFilterCtrl" placeholderLabel="{{placeholderLabel()}}"
        noEntriesFoundLabel="no entries found" />
      </mat-option>
      @for (element of filteredListElements | async; track element) {
        <mat-option [value]="element">
          {{element.name}}
        </mat-option>
      }
    </mat-select>
    @if (currentElementId() && !disabled() && showClose()==='true') {
      <button mat-icon-button matSuffix aria-label="Clear" (click)="clearSelection($event)">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
</div>
